var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAgeRating18 = function SvgAgeRating18(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2497 0C19.7686 0 21 1.23137 21 2.75034V18.2497C21 19.7686 19.7686 21 18.2497 21H2.75034C1.23137 21 0 19.7686 0 18.2497V2.75034C0 1.23137 1.23137 0 2.75034 0H18.2497Z",
    fill: "#D54E4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37764 9.55244H10.7002C11.1091 8.07982 12.4477 7 14.0359 7C15.9491 7 17.5 8.567 17.5 10.5C17.5 12.433 15.9491 14 14.0359 14C12.4516 14 11.1158 12.9255 10.7032 11.4585H8.37764V14H6.66456V11.4585H5.24548V14H3.5V9.55244H6.66456H8.37764ZM15.6105 10.5C15.6105 11.3786 14.9055 12.0909 14.0359 12.0909C13.1662 12.0909 12.4613 11.3786 12.4613 10.5C12.4613 9.62137 13.1662 8.90909 14.0359 8.90909C14.9055 8.90909 15.6105 9.62137 15.6105 10.5Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgeRating18, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/age_rating_18.662c8e14.svg";
export { ForwardRef as ReactComponent };